import { DatePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxI18nService } from '@studiohyperdrive/ngx-i18n';
import { BtwPipe } from '@studiohyperdrive/ngx-utils';

import { CypressTagDirective } from '@cjm/cypress/core';
import { VLoketAppRoutePaths } from '@cjm/shared/route-paths';
import { FaIconComponent, TagComponent } from '@cjm/shared/ui/common';
import { OneLineAddressPipe } from '@cjm/shared/utils';

import { AssociationDetailEntity, MyAssociationEntity } from '../../../data';
import { I18nKeys } from '../../../i18n';
import { MainContactInfoPipe, MainLocationPipe, AssociationNamePipe } from '../../pipes';
import { AssociationDetailActivitiesComponent } from '../association-detail-activities/association-detail-activities.component';
import { AssociationTargetAudienceTagsComponent } from '../association-target-audience-tags/association-target-audience-tags.component';

@Component({
	selector: 'vloket-association-card',
	templateUrl: './association-card.component.html',
	styleUrls: ['association-card.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		NgClass,
		RouterLink,
		TagComponent,
		FaIconComponent,
		TranslateModule,
		BtwPipe,
		AssociationNamePipe,
		AssociationDetailActivitiesComponent,
		AssociationTargetAudienceTagsComponent,
		MainLocationPipe,
		OneLineAddressPipe,
		MainContactInfoPipe,
		DatePipe,
		CypressTagDirective
	]
})
export class AssociationCardComponent {
	@Input() public association: MyAssociationEntity | AssociationDetailEntity;
	@Input() public classes: string;
	@Input() public disableShadow: boolean = false;
	@Input() public withLink: boolean = false;
	@Input() public target: '_self' | '_blank' | '_parent' | '_top' = '_self';
	@Input() public link: string | string[];

	public readonly i18nKeys: typeof I18nKeys = I18nKeys;
	public readonly appRoutes: typeof VLoketAppRoutePaths = VLoketAppRoutePaths;

	constructor(public readonly i18nService: NgxI18nService) {}

	protected readonly I18nKeys = I18nKeys;
}
